import useSWR from "swr";
import { environment } from "../config/environment";
import { OrganisationFilePaginatedResponse } from "@attelas/shared";
import { useSWRFetcher } from "./useSWRFetcher";

type UseOrganisationFilesParams = {
  searchTerm?: string;
  pageNumber?: number;
  pageSize?: number;
  enabled?: boolean;
};

function buildUrl(params: UseOrganisationFilesParams): string {
  const url = new URL(`${environment.apiUrl}/api/files`);
  if (params.searchTerm != null && params.searchTerm !== "") {
    url.searchParams.set("searchTerm", params.searchTerm);
  }
  if (params.pageNumber != null) {
    url.searchParams.set("pageNumber", String(params.pageNumber));
  }
  if (params.pageSize != null) {
    url.searchParams.set("pageSize", String(params.pageSize));
  }
  return url.toString();
}

export function useOrganisationFiles(params: UseOrganisationFilesParams = {}) {
  const { enabled = true, ...queryParams } = params;
  const fetcher = useSWRFetcher();
  const url = buildUrl(queryParams);

  const { data, isLoading, error, mutate } = useSWR<OrganisationFilePaginatedResponse>(
    enabled ? url : null,
    (url: string) => fetcher<OrganisationFilePaginatedResponse>(url)
  );

  return {
    files: data?.items ?? [],
    totalCount: data?.totalCount ?? 0,
    pageNumber: data?.pageNumber,
    pageSize: data?.pageSize,
    isLoading,
    error,
    refetch: mutate,
  };
}
